// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__XA-UF","topBottomGutter":"Layout_topBottomGutter__quKsY"};